$(() => {
	$('p,h1,h2,h3,h4,h5,h6').each(function (index, element) {
		$(element).html(
			$(element)
				.html()
				.replace(/&nbsp;/g, '')
		);
	});
});
